import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ResultItemProduct from "components/organisms/ResultItemProduct";
import classnames from "classnames";

const ResultList = (props) => {
  const {
    className,
    coverFallbackImg,
    records = [],
    supportingSeriesData,
    offset,
    focusFirstNewItem,
    onFocusFirstNewItemDone,
  } = props;
  const componentBaseClass = "sal-result-list";
  const componentClass = classnames(componentBaseClass, className);
  const firstNewItem = useRef(null);

  useEffect(() => {
    // data is loaded (new ref) and we have not focused yet
    if (focusFirstNewItem && firstNewItem.current) {
      firstNewItem.current.focus();
      onFocusFirstNewItemDone();
    }
  }, [firstNewItem.current]);

  const recordsJsx = records.map((record, index) => (
    <li
      key={index}
      id={componentBaseClass + "-entry-" + index}
      className={componentBaseClass + "__list-item"}
    >
      <ResultItemProduct
        additionalLicenses={record["additional_licenses"]}
        coverFallbackImg={coverFallbackImg}
        coverUri={record["cover-uri"]}
        dateExpectedPublication={record["date-expected-publication"]}
        datePublication={record["date-publication"]}
        detailUri={record["detail-uri"]}
        displayTitleHeading={record["display-title-heading"]}
        displayTitleSubheading={record["display-title-subheading"]}
        displayTitleInfo={record["display-title-info"]}
        identifier={record["identifier"]}
        isbn={record["isbn"]}
        isEstimatedPrice={record["is-estimated-price"]}
        isFreeInAbo={record["is-free-in-abo"]}
        isNew={record["is-new"]}
        licenseFormShort={record["license-form-short"]}
        priceEur={record["price-eur"]}
        publishingHouse={record["publishing-house"]}
        schoolSubjects={record["school-subjects"]}
        supportedBySeries={record["supported_by_series"]}
        supportingSeriesData={supportingSeriesData}
        highestQuantityScalePrice={record["highest_quantity_scale_price"]}
        ref={index === offset ? firstNewItem : null}
      />
    </li>
  ));

  return <ol className={componentClass}>{recordsJsx}</ol>;
};

ResultList.propTypes = {
  className: PropTypes.string,
  coverFallbackImg: PropTypes.string,
  records: PropTypes.arrayOf(
    PropTypes.shape({
      additional_licenses: PropTypes.arrayOf(PropTypes.string),
      brand: PropTypes.string,
      "cover-uri": PropTypes.string,
      "date-expected-publication": PropTypes.string,
      "date-publication": PropTypes.string,
      demo_exists: PropTypes.bool,
      "detail-uri": PropTypes.string,
      "display-title-heading": PropTypes.string.isRequired,
      "display-title-subheading": PropTypes.arrayOf(PropTypes.string),
      "display-title-info": PropTypes.arrayOf(PropTypes.string),
      "is-estimated-price": PropTypes.bool,
      "is-free-in-abo": PropTypes.bool,
      "is-new": PropTypes.bool,
      "license-form": PropTypes.string,
      "license-form-short": PropTypes.string,
      "price-eur": PropTypes.number,
      highest_quantity_scale_price: PropTypes.objectOf(
        PropTypes.shape({
          amount: PropTypes.number.isRequired,
          gross_eurocent: PropTypes.number.isRequired,
        }),
      ),
    }),
  ).isRequired,
  supportingSeriesData: PropTypes.objectOf(
    PropTypes.shape({
      linkLabel: PropTypes.string,
      linkTarget: PropTypes.string,
      teaserImageSrc: PropTypes.string,
    }),
  ),
  offset: PropTypes.number,
  focusFirstNewItem: PropTypes.bool,
  onFocusFirstNewItemDone: PropTypes.func,
};

export default ResultList;
